<template>
  <v-card-text class="pa-0">
    <v-form ref="scheduleForm">
      <condominium-box :value="schedule"></condominium-box>
      <v-layout row wrap mb-2 v-if="!scheduleEditing">
        <v-flex :class="{'w-49': !scheduleDone}" xs12 s6 md6>
          <template v-if="!alteredScheduleSaving">
            <send-email></send-email>
          </template>          
        </v-flex>
        <v-spacer v-show="!scheduleDone"></v-spacer>
        <v-flex class="w-49" xs12 s6 md6 v-if="!alteredScheduleSaving">
          <v-layout row wrap class="condominium-box mb-3 pt-3 pb-2 pl-3 pr-3" v-if="schedule.status === 0">
            <v-flex xs12 mb-2>
              <h6>Visita</h6>
            </v-flex>
            <v-flex xs12 mb-2>
              <v-divider></v-divider>
            </v-flex>
            <v-flex class="text-xs-center">
              <cancel-warning v-if="!loadingScheduleActions">
                <v-btn flat color="red" :disabled="!schedule.sent"><v-icon left>event</v-icon>Cancelar agendamento</v-btn>
              </cancel-warning>
              <div v-else class="text-xs-center">
                <v-btn flat color="red" :disabled="loadingScheduleActions || !schedule.sent"><v-icon left>event</v-icon>Cancelar agendamento</v-btn>
              </div>
            </v-flex>
            <v-flex xs12 mb-2>
              <v-divider></v-divider>
            </v-flex>
            <v-flex class="text-xs-center">
              <v-btn flat color="green" :disabled="loadingScheduleActions" @click="finishSchedule"><v-icon left>done_all</v-icon>Agendamento realizado</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-form>
  </v-card-text>
</template>

<script>
import condominiumBox from './CondominiumBox'
import cancelWarning from '../cancelWarning'
import sendEmail from '../SendEmail'
export default {
  name: 'schedule-details',
  components: {
    'cancel-warning': cancelWarning,
    'send-email': sendEmail,
    'condominium-box': condominiumBox
  },
  methods: {
    cancelChange () {
      this.$store.commit('cancelChange')
    },
    alterSchedule () {
      this.$store.dispatch('alterSchedule')
    },
    finishSchedule () {
      this.$store.dispatch('finishSchedule')
    }
  },
  computed: {
    scheduleEditing () {
      return this.$store.getters.scheduleEditing
    },
    schedule () {
      return this.$store.getters.selectedSchedule
    },
    scheduleDone () {
      return this.$store.getters.scheduleDone
    },
    loadingScheduleActions () {
      return this.$store.getters.loadingScheduleActions
    },
    alteredScheduleDateWarning () {
      return this.$store.getters.alteredScheduleDateWarning
    },
    alteredSchedule () {
      return this.$store.getters.alteredSchedule
    },
    registeredItems () {
      return this.$store.getters.registeredItems
    },
    alteredScheduleSaving () {
      return this.$store.getters.alteredScheduleSaving
    }
  }
}
</script>
<style>
.w-49{
  -ms-flex-preferred-size: 49%;
  flex-basis: 49%;
  max-width: 49%;
}
.margin-bootom {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// ScheduleDetails.vue?487a0b78